/** world_elements.portrait stores a basename; portraitUrl is an API convenience.
 * Both list and reopened editor must resolve the persisted value identically.
 */
export function worldPortraitUrl(row: unknown): string | null {
  if (!row || typeof row !== 'object') return null;
  const record = row as Record<string, unknown>;
  const url = [record.portraitUrl, record.portrait]
    .find((value): value is string => typeof value === 'string' && value.trim().length > 0)?.trim();
  if (!url || url.startsWith('//') || url.includes('\\')) return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (/^[a-z][a-z\d+.-]*:/i.test(url) || url.split('/').some((part) => part === '..' || part === '.')) return null;
  if (url.startsWith('/') || url.includes('/')) return url;
  return /^[\w.-]+$/.test(url) ? `/uploads/portraits/${url}` : null;
}
